// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_wrapper_zlvm1icfXKMbvc9m3Gym {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.style-module_wrapper_zlvm1icfXKMbvc9m3Gym h3 {
  margin: 1rem;
}

.style-module_icon_RaM3QMD9uCLkgvonH2w6 {
  margin-bottom: 1em;
}`, "",{"version":3,"sources":["webpack://./src/containers/LoginForbidden/style.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,kBAAA;AAAF","sourcesContent":[".wrapper {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  h3 {\n    margin: 1rem;\n  }\n}\n\n.icon {\n  margin-bottom: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style-module_wrapper_zlvm1icfXKMbvc9m3Gym`,
	"icon": `style-module_icon_RaM3QMD9uCLkgvonH2w6`
};
export default ___CSS_LOADER_EXPORT___;
